<!-- Карточка read-only секции заказа в текущем визуальном стиле карточки заказа -->
<template>
  <div class="order-info-card">
    <BaseActionHeader
      class="order-info-card__header"
      spacing="none"
      title-tag="div"
    >
      <template #title>
        <div class="order-info-card__heading">
          <div v-if="$slots.icon" class="order-info-card__icon">
            <slot name="icon" />
          </div>
          <h4 class="order-info-card__title">{{ title }}</h4>
          <span class="order-info-card__count" v-if="count !== null">
            {{ count }}
          </span>
        </div>
      </template>
      <template v-if="$slots.actions" #default>
        <slot name="actions" />
      </template>
    </BaseActionHeader>
    <div class="order-info-card__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderInfoCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style scoped>
.order-info-card {
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  background: #fff;
}

.order-info-card__header {
  padding: var(--base-in-indent);
  background: rgb(240, 240, 240);
  border-bottom: 1px solid #e8e8e8;
}

.order-info-card__heading {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.order-info-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.order-info-card__title {
  flex: 1;
  margin: 0;
  color: var(--color-dark);
  font-size: 16px;
  font-weight: 600;
}

.order-info-card__count {
  min-width: 20px;
  padding: 3px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background: #667eea;
  border-radius: 12px;
}

.order-info-card__content {
  padding: var(--base-in-indent);
}
</style>
